import * as actionTypes from '../../action-types';
import * as actionParams from '../../action-params';

class GoogleAnalytics {

  constructor(config) {
    this.config = config;
  }

  loadScript() {
    return new Promise((res, rej) => {
      // eslint-disable-next-line no-undef
      $.getScript(
        `https://www.googletagmanager.com/gtag/js?id=${this.config.key}`,
      )
        .done(() => {
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', this.config.key);
          res();
        })
        .fail(rej);
    });
  }

  push(action) {

  }

}

export default GoogleAnalytics;
